// removed by extract-text-webpack-plugin
module.exports = {"container":"antd-pro-header-dropdown-container"};


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/src/components/HeaderDropdown/index.less
// module id = 1133
// module chunks = 0